/**
 * Form-field renderers other modules provide for ELC forms.
 *
 * ELC renders reference fields with FormRefPicker. A module that owns a
 * richer control registers it here for a field type, the way OAM
 * registers its workflow step types into ELC's step registry; ELC never
 * imports the module. OAM registers the desk map picker for ``desk_ref``
 * (owner, 2026-10-24).
 */
import type { ComponentType } from 'react';

export interface FormFieldRendererProps {
  /** The field's label text. */
  label: string;
  /** Id of the element holding the label: renderers sit in a plain
   * container (not a <label>), so point controls at it with aria-labelledby. */
  labelId: string;
  /** A string, or a list for plural types (``desk_refs``). */
  value: string | string[];
  /** The whole form's values, for controls that depend on another field. */
  formValues: Readonly<Record<string, unknown>>;
  required?: boolean;
  onChange: (value: string | string[]) => void;
}

const renderers = new Map<string, ComponentType<FormFieldRendererProps>>();

export function registerFormFieldRenderer(type: string, component: ComponentType<FormFieldRendererProps>): void {
  renderers.set(type, component);
}

export function formFieldRenderer(type: string): ComponentType<FormFieldRendererProps> | undefined {
  return renderers.get(type);
}
